require('popper.js')
require('bootstrap')
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('data-confirm-modal')

import "./gym_user"
